import { render, staticRenderFns } from "./AttributeTimelineNumeric.vue?vue&type=template&id=54fffdbf&scoped=true"
import script from "./AttributeTimelineNumeric.vue?vue&type=script&lang=ts"
export * from "./AttributeTimelineNumeric.vue?vue&type=script&lang=ts"
import style0 from "./AttributeTimelineNumeric.vue?vue&type=style&index=0&id=54fffdbf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fffdbf",
  null
  
)

export default component.exports